var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{on:{"click":_vm.downloadPdf}},[_vm._v(".PDF para Negocios BeCupon")])])
}
var staticRenderFns = []

export { render, staticRenderFns }